import {NavItem} from "../SingIn/types";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import {ChevronDownIcon, ChevronUpIcon, ChatIcon} from "@heroicons/react/outline";

// Icon mapping for string identifiers to components
const iconMap: Record<string, React.ComponentType<{ className: string; "aria-hidden": boolean }>> = {
    chat: ChatIcon,
};

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(' ')
}

interface NavigationMenuItemProps {
    item: NavItem;
    setDialogOpen: (open: boolean) => void;
}

const NavigationMenuItem: React.FC<NavigationMenuItemProps> = ({ item, setDialogOpen }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const hasSubDashboards = item.sub_dashboards && item.sub_dashboards.length > 0;

    const isActive =
        window.location.pathname.includes(item.slug) ||
        (item.sub_dashboards?.some((subItem) => window.location.pathname.includes(subItem.slug)) ?? false);


    const toggleExpand = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if(hasSubDashboards){
            e.preventDefault(); // Prevent default navigation if there are sub dashboards
            setIsExpanded(!isExpanded);
        }
    };

    const handleSubMenuItemPress = (
        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
        subItem: NavItem
    ) => {
        if (!subItem.dashboard_id || subItem.dashboard_id.length === 0) {
            // Prevent default navigation
            e.preventDefault();
            setDialogOpen(true);
        }
    };

    return (
        <div>
            {item.isShowTopDivider && (
                <>
                    <div className="h-3" />
                    <div className="border-t border-white content-center border-opacity-20" />
                    <div className="h-3" />
                </>
            )}
            <div className="flex flex-col">
                <Link
                    to={{
                        pathname: hasSubDashboards ? undefined : item.slug,
                        state: {menu_item: item.dashboard_id ? item : null},
                    }}
                    className={classNames(
                        isActive
                            ? "text-white font-bold bg-black bg-opacity-20"
                            : "text-white text-opacity-80 font-medium hover:bg-black hover:bg-opacity-20 hover:text-white",
                        "group flex items-center px-6 py-2 text-sm"
                    )}
                    onClick={(e) => toggleExpand(e)}
                >
                    {item.icon && iconMap[item.icon] && React.createElement(iconMap[item.icon], { className: "mr-3 h-6 w-6 text-white", "aria-hidden": true })}
                    {item.name}
                    {
                        hasSubDashboards &&
                        <span className="ml-auto">
                            { isExpanded ? <ChevronDownIcon className="h-4 w-4 text-white" aria-hidden="true"/> : <ChevronUpIcon className="h-4 w-4 text-white" aria-hidden="true"/> }
                        </span>
                    }
                </Link>
                {isExpanded && hasSubDashboards && (
                    <div className={`pl-12 pb-4 ${isActive ? "bg-black bg-opacity-20" : ""}`}>
                        {item.sub_dashboards?.map((subItem) => (
                            <Link
                                key={subItem.id}
                                to={{
                                    pathname: subItem.slug,
                                    state: { menu_item: subItem.dashboard_id ? subItem : null },
                                }}
                                className={classNames(
                                    window.location.href.includes(subItem.slug)
                                        ? "text-white font-bold"
                                        : "text-white text-opacity-80 hover:text-white",
                                    "block py-2 text-sm"
                                )}
                                onClick={(e) => handleSubMenuItemPress(e, subItem)} // Pass the event to the handler
                            >
                                {subItem.name}
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default NavigationMenuItem;
